import StorageHandler from './StorageHandler.js';
import Helpers from './Helpers.js';

class RestAPI {
    constructor() {
        if (RestAPI.instance) return RestAPI.instance;

        document.addEventListener('filterDataChanged', () => {
            const apiParameters = this.assembleParameters();
            this.fetchData(apiParameters);
        });

        // Cache to reduce similar queries
        this.cache = new Map();
        RestAPI.instance = this;
    }

    assembleParameters() {
        // Get data from storage
        const rawParameters = StorageHandler.instance.fetchData();
        let params = {};
        const helpers = new Helpers();
        const serviceTypeId = helpers.getServiceTypeIdFromCurrentUrl();

        if(rawParameters.length > 0) {
            // Reduce the data, mapping slugs to values
            params = rawParameters.reduce((acc, item) => {
                if (!acc[item.slug]) {
                    acc[item.slug] = [];
                }
                acc[item.slug].push(item.value);
                return acc;
            }, {});

            // Convert arrays to comma-separated strings
            for (const slug in params) {
                params[slug] = params[slug].join(',');
            }
        }

        // Add service-type param if applicable
        if (serviceTypeId !== false) {
            params['service-type'] = serviceTypeId;
        }

        // Parse data to be useful for the WP REST API call
        if(Object.keys(params).length > 0) {
            return '?' + new URLSearchParams(params).toString();
        }

        return false;
    }

    async fetchData(param = null) {
        const key = param ? param : '';

        // Check cache first
        if (this.cache.has(key)) {
            console.log('Returning cached result for', (key.length > 0) ? key : 'global query');
            const cached = this.cache.get(key);
            this._dispatchEvent(cached);
            return cached;
        }

        try {
            const response = await fetch(window.location.origin + `/wp-json/klaarnoord/v1/locations/${key}`);
            if (!response.ok) {
                console.error('Error on REST response: ' + response);
            }

            const data = await response.json();

            // Save to cache
            this.cache.set(key, data);

            this._dispatchEvent(data);
            return data;
        } catch (err) {
            console.error('Fetch error:', err);
        }
    }

    _dispatchEvent(data) {
        const event = new CustomEvent('apiDataFetched', { detail: data });
        document.dispatchEvent(event);
    }
}

export default RestAPI;
